import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-track-type',
  templateUrl: './track-type.dialog.html',
  styleUrls: ['./track-type.dialog.scss']
})
export class TrackTypeDialog implements OnInit {
  trackTypeForm: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<TrackTypeDialog>
    ) {
  }

  ngOnInit(): void {
    this.trackTypeForm = new FormGroup({
      typeOptions: new FormControl('', Validators.required),
    });
  }
  cancel(): void {
    this.dialogRef.close({ saveData: false });
  }
  onSubmit() {
    if (this.trackTypeForm.valid) {
      this.dialogRef.close({
        saveData: true,
        response: this.trackTypeForm.value
      });
    }
  }

}
